var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticStyle:{"font-size":"3rem"}},[_vm._v("维护中...")])])
}]

export { render, staticRenderFns }